import React from 'react'
import styled from 'styled-components'

import confettiImg from '@/images/confetti.gif'

import { mobile } from '../../utils/media-query'
import { sectionMobileMargin } from '../../constants'

import Carousel from './carousel'

const KitCarouselContainer = styled.div`
  width: 100%;
  margin-bottom: 10px;

  ${mobile.css`
        margin-bottom: ${sectionMobileMargin}px;
    `}
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 100px;
  }

  p {
    font-size: 20px;
    line-height: 28px;
  }

  ${mobile.css`
        display: none;

    `}
`

const Content = styled.div`
  display: flex;
  flex-direction: column;

  ${mobile.css`
        width: 100%;
        margin: auto;
        flex-direction: column-reverse;
    `}
`

const KitCarousel = () => {
  return (
    <KitCarouselContainer>
      <Header>
        <img alt="" src={confettiImg} />
        <h1>What&#39;s in the Kit?</h1>
      </Header>
      <Content>
        <Carousel />
      </Content>
    </KitCarouselContainer>
  )
}

export default KitCarousel
